export default "__VITE_ASSET__a93ac4b6__"